import React from 'react';
import { Router, routes } from './router/Router';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './assets/css/style.css';
import { BrandingProvider } from './context/BrandingContext';
import { Toaster } from 'react-hot-toast';

function App() {

  const domain = window.location.hostname;

  if (domain.includes('app.onlinemasterscolleges.com')) {
    document.body.classList.add('theme-domain1');
  } else if (domain.includes('domain2.com')) {
    document.body.classList.add('theme-domain2');
  }
  else {
    document.body.classList.add('theme-domain1');
  }
  return (
    <>
      <BrandingProvider>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Router />} >
              {routes.map((route, i) => (<Route exact={true} path={route.path} key={i} element={
                route.component
              } />))}
              <Route element={<Navigate to='/' replace />} />
            </Route>
          </Routes>
        </BrowserRouter>

        {/* ✅ Global toaster - can be styled or positioned */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            success: {
              style: { background: 'White', color: 'black' },
            },
            error: {
              style: { background: 'red', color: 'white' },
            },
          }}
        />

      </BrandingProvider>
    </>
  );
}

export default App;
